/* ========================================================================
* Bootstrap: collapse.js v3.3.5
* http://getbootstrap.com/javascript/#collapse
* ========================================================================
* Copyright 2011-2015 Twitter, Inc.
* Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
* ======================================================================== */

+function($) {
    'use strict';

    // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
    // ============================================================

    /**
     * CSS transition support.
     *
     * @returns {mixed} Transition type.
     */
    function transitionEnd() {
        var el = document.createElement('bootstrap');

        var transEndEventNames = {
            WebkitTransition: 'webkitTransitionEnd',
            MozTransition: 'transitionend',
            OTransition: 'oTransitionEnd otransitionend',
            transition: 'transitionend'
        };

        for (var name in transEndEventNames) {
            if (el.style[name] !== undefined) {
                return {
                    end: transEndEventNames[name]
                };
            }
        }

        // explicit for ie8 (  ._.)
        return false;
    }

    // http://blog.alexmaccaw.com/css-transitions
    $.fn.emulateTransitionEnd = function(duration) {
        var called = false;
        var $el = this;

        $(this).one('bsTransitionEnd', function() { called = true; });

        /**
         * @returns {Function} Triggers transition end.
         */
        function callback() { if (!called) $($el).trigger($.support.transition.end); };
        setTimeout(callback, duration);

        return this;
    };

    $(function() {
        $.support.transition = transitionEnd();

        if (!$.support.transition) return;

        $.event.special.bsTransitionEnd = {
            bindType: $.support.transition.end,
            delegateType: $.support.transition.end,

            /**
             * 'bsTransitionEnd' event handler.
             *
             * @param   {Event} e - Event object.
             * @returns {void}
             */
            handle: function(e) {
                if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments);
            }
        };
    });
}(jQuery);

+function($) {
    'use strict';

    /**
     * Collapse.
     *
     * @class
     * @param {HTMLElement} element - The HTML element the Collapse should be bound to.
     * @param {Object} options - An option map.
     */
    function Collapse(element, options) {
        this.$element      = $(element);
        this.options       = $.extend({}, Collapse.DEFAULTS, options);
        this.id            = element.id;
        this.$selector      = $('[data-toggle="collapse"][href="#' + this.id + '"],' +
            '[data-toggle="collapse"][data-target="#' + this.id + '"]');
        this.$trigger = this.$selector.length ? this.$selector : $(this.options.trigger);
        this.transitioning = null;
        this.$scrollable   = this.$element;

        var collapseContainer = this.$element.find('.collapse__container');

        if (collapseContainer.length) {
            // this.$arrow        = $('<div class="collapse__arrow"></div>');
            this.$close        = $('<a href="#" data-toggle="collapse" class="collapse__close">' + rkas.icon.render('#close-round') + '</a>');

            if (collapseContainer.hasClass('collapse__container--no-close')) {
                this.$close = false;
            }
            // if (collapseContainer.hasClass('collapse__container--no-arrow')) {
            //     this.$arrow = false;
            // }
        }

        if (this.options.parent) {
            this.$parent = this.getParent();
        } else {
            this.addAriaAndCollapsedClass(this.$element, this.$trigger);
        }

        if (this.options.toggle) this.toggle();
    };

    Collapse.VERSION  = '3.3.5';

    Collapse.TRANSITION_DURATION = 350;

    Collapse.DEFAULTS = {
        toggle: false,
        scrollSpeed: 500,
        topNavHeight: 50,
        newLocationOffset: 60,
        threshold: 100,
        autoScroll: false,

        /**
         * Callback function for content loading.
         *
         * @returns {void}
         */
        loadContent: function() {}
    };

    /**
     * Get element dimensions.
     *
     * @function dimension
     * @returns {string} Dimensions.
     */
    Collapse.prototype.dimension = function() {
        var hasWidth = this.$element.hasClass('width');

        return hasWidth ? 'width' : 'height';
    };

    /**
     * Show collapse.
     *
     * @function show
     * @param  {boolean} noScroll - If scrolling is allowed.
     * @returns {void}
     */
    Collapse.prototype.show = function(noScroll) {
        var shouldAnimate = true;

        if (this.$element.data('collapse-animate') != undefined) {
            shouldAnimate = this.$element.data('collapse-animate');
        }

        var that = this;

        if (this.transitioning || (this.$element.hasClass('is-visible') && this.$element.hasClass('collapse--visible'))) {
            if (!noScroll) {
                this.scroll(false);
            }

            return;
        }

        if (this.$trigger.data('content') == 'ajax') {
            this.options.loadContent.call(this, this.$element, loadContentReady);
        } else {
            showcontent.call(this);
        }

        /**
         * Load content ready.
         *
         * @param  {HTMLElement} html - HTML to be appended.
         * @returns {void}
         */
        function loadContentReady(html) {
            that.$element.find('.collapse__container').empty().append(html);
            showcontent.call(that);
        }

        /**
         * Show collapse content.
         *
         * @returns {void}
         */
        function showcontent() {
            var activesData;
            var actives = that.$parent && this.$parent.find('.collapse--visible, .collapse--collapsing, .collapse.is-visible, .collapse.is-collapsing');

            if (actives && actives.length) {
                activesData = actives.data('bs.collapse');
                if (activesData && activesData.transitioning) return;
            }

            var event = $.Event('show.bs.collapse');

            that.$element.trigger(event);
            if (event.isDefaultPrevented()) return;

            if (actives && actives.length) {
                Plugin.call(actives, 'hide');
                activesData || actives.data('bs.collapse', null);
            }

            var dimension = this.dimension();

            if (!shouldAnimate) {
                that.$element
                    .addClass('collapse--visible is-visible')[dimension](0)
                    .attr('aria-expanded', true)
                    // .prepend(this.$arrow);
            } else {
                that.$element
                    .removeClass('collapse')
                    .addClass('collapse--collapsing is-collapsing')[dimension](0)
                    .attr('aria-expanded', true)
                    // .prepend(this.$arrow);
            }

            $(document).trigger('refresh.rkas', that.$element[0]);

            this.$trigger
                .removeClass('collapsed').addClass('is-active')
                .attr('aria-expanded', true);

            this.transitioning = 1;

            if (this.$trigger.length) {
                // filters
                // this.setArrowPosition();
            }

            /**
             * Complete transition.
             *
             * @returns {void}
             */
            function complete() {
                that.$element
                    .removeClass('collapse--collapsing is-collapsing')
                    .addClass('collapse collapse--visible is-visible')[dimension]('');
                this.transitioning = 0;
                that.$element
                    .trigger('shown.bs.collapse')
                    .prepend(this.$close);

                this.setCloseButtonAction();

                $(window).trigger('resize');
            };

            if (!noScroll) {
                this.scroll(true);
            }

            this.setCollapseText();
            this.setCollapseIcon();

            if (!$.support.transition) return complete.call(this);

            var scrollSize = $.camelCase(['scroll', dimension].join('-'));

            that.$element
                .one('bsTransitionEnd', $.proxy(complete, this))
                .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](that.$element[0][scrollSize]);

            if (this.$close) {
                this.$close.on('click', function(event) {
                    event.preventDefault();
                });
            }

            $(window).on('resize.rkas.collapse.' + this.id, this.resizeHandler.bind(this));
        }
    };

    /**
     * Handle window resize.
     *
     * @function resizeHandler
     * @returns {void}
     */
    Collapse.prototype.resizeHandler = function() {
        if (this.$trigger.length) {
            // this.setArrowPosition();
        }
    };

    /**
     * Scroll to collapse.
     *
     * @function scroll
     * @param  {boolean} setEvent - If event has to be set.
     * @returns {void}
     */
    Collapse.prototype.scroll = function(setEvent) {
        var event;
        var that = this;

        if (!this.options.autoScroll) {
            return;
        }

        if (setEvent) {
            this.$element.one('shown.bs.collapse', function() {
                scroller();
            });
        } else {
            scroller();
        }

        /**
         * Scroll to collapse.
         *
         * @returns {void}
         */
        function scroller() {
            event = $.Event('scroll.bs.collapse');
            that.$element.trigger(event);
            if (!that.$scrollable.isOnScreen(that.options.threshold)) {
                event = $.Event('scrolling.bs.collapse');
                that.$element.trigger(event);
                window.autoScroll(that.$scrollable, that.options.scrollSpeed, that.options.newLocationOffset);
            }

            event = $.Event('scrolled.bs.collapse');
            that.$element.trigger(event);
        }
    };

    /**
     * Hide collapse.
     *
     * @function hide
     * @returns {void}
     */
    Collapse.prototype.hide = function() {
        var shouldAnimate = true;

        if (this.$element.data('collapse-animate') != undefined) {
            shouldAnimate = this.$element.data('collapse-animate');
        }
        if (this.transitioning || (!this.$element.hasClass('collapse--visible') && !this.$element.hasClass('is-visible'))) return;

        var event = $.Event('hide.bs.collapse');

        this.$element.trigger(event);
        if (event.isDefaultPrevented()) return;

        var dimension = this.dimension();

        this.$element[dimension](this.$element[dimension]())[0].offsetHeight;

        if (!shouldAnimate) {
            this.$element
                .removeClass('collapse--visible is-visible')
                .attr('aria-expanded', false);
        } else {
            this.$element
                .addClass('collapse--collapsing is-collapsing')
                .removeClass('collapse collapse--visible is-visible')
                .attr('aria-expanded', false);
        }

        this.$trigger
            .removeClass('is-active').addClass('collapsed')
            .attr('aria-expanded', false);

        this.transitioning = 1;

        /**
         * Complete transition.
         *
         * @returns {void}
         */
        function complete() {
            this.transitioning = 0;
            this.$element
                .removeClass('collapse--collapsing is-collapsing')
                .addClass('collapse')
                .trigger('hidden.bs.collapse');

            $(window).trigger('resize');
        };

        $(document).trigger('reset.rkas', this.$element[0]);

        this.setCollapseText();
        this.setCollapseIcon();

        if (!$.support.transition) return complete.call(this);

        this.$element[dimension](0)
            .one('bsTransitionEnd', $.proxy(complete, this))
            .emulateTransitionEnd(Collapse.TRANSITION_DURATION);

        $(window).off('resize.rkas.collapse.' + this.id);
    };

    /**
     * Toggle collapse.
     *
     * @function toggle
     * @returns {void}
     */
    Collapse.prototype.toggle = function() {
        this[(this.$element.hasClass('collapse--visible') || this.$element.hasClass('is-visible')) ? 'hide' : 'show']();
    };

    /**
     * Get parent element.
     *
     * @function getParent
     * @returns {JQuery} Parent element.
     */
    Collapse.prototype.getParent = function() {
        return $(this.options.parent)
            .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
            .each($.proxy(function(i, element) {
                var $element = $(element);

                this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element);
            }, this))
            .end();
    };

    /**
     * Add aria and toggle class for trigger.
     *
     * @function addAriaAndCollapsedClass
     * @param  {JQuery} $element - Collapse element.
     * @param  {JQuery} $trigger - Collapse trigger element.
     * @returns {void}
     */
    Collapse.prototype.addAriaAndCollapsedClass = function($element, $trigger) {
        var isOpen = $element.hasClass('collapse--visible') || $element.hasClass('is-visible');

        $element.attr('aria-expanded', isOpen);
        $trigger
            .toggleClass('collapsed', !isOpen)
            .toggleClass('is-active', isOpen)
            .attr('aria-expanded', isOpen);
    };

    // /**
    //  * Set arrow position.
    //  *
    //  * @function setArrowPosition
    //  * @returns {void}
    //  */
    // Collapse.prototype.setArrowPosition = function() {
    //     // if (this.$arrow) {
    //     //     var left = this.$trigger.offset().left - this.$element.offset().left + this.$trigger.outerWidth() / 2 - 10;
    //     //
    //     //     this.$arrow.css({
    //     //         left: left
    //     //     });
    //     // }
    // };

    /**
     * Set close button link.
     *
     * @function setCloseButtonAction
     * @returns {void}
     */
    Collapse.prototype.setCloseButtonAction = function() {
        if (this.$close) {
            this.$close.attr('href', '#' + this.id);
        }
    };

    /**
     * Set collapse trigger text.
     *
     * @function setCollapseText
     * @returns {void}
     */
    Collapse.prototype.setCollapseText = function() {
        this.$trigger.each(function() {
            var $this = $(this);

            if (!$this.data('more-text') || !$this.data('less-text')) {
                return;
            }
            var newText = $this.hasClass('is-active') ? $this.data('less-text') : $this.data('more-text');

            setTimeout(function() {
                if ($this.hasClass('collapse-toggle')) {
                    $this.find('.btn__text').html(newText);
                } else {
                    $this.html(newText);
                }
            }, 100);
        });
    };

    /**
     * Set collapse trigger icon.
     *
     * @function setCollapseIcon
     * @returns {void}
     */
    Collapse.prototype.setCollapseIcon = function() {
        this.$trigger.each(function() {
            var $this = $(this);

            if (!$this.data('more-icon') || !$this.data('less-icon')) {
                return;
            }
            var newIcon = $this.hasClass('is-active') ? $this.data('less-icon') : $this.data('more-icon');

            setTimeout(function() {
                if ($this.hasClass('collapse-toggle')) {
                    var icon = $this.find('.collapse-toggle__icon');

                    if (icon.find('use').length) {
                        // if the browser supports external use
                        icon.find('use').attr('xlink:href', rkas.svg_path + newIcon);
                    } else {
                        // if the browser does not support external use and is polyfilled
                        icon.children().replaceWith('<use xlink:href="' + rkas.svg_path + newIcon + '"></use>');
                    }
                }
            }, 100);
        });
    };

    /**
     * Gets target element from trigger.
     *
     * @function getTargetFromTrigger
     * @param  {JQuery} $trigger - Trigger JQuery element.
     * @returns {JQuery} Target jQuery element.
     */
    function getTargetFromTrigger($trigger) {
        var href;
        // strip for ie7
        var target = $trigger.attr('data-target') || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '');

        return $(target);
    }

    /**
     * Create plugin.
     *
     * @param {Object} option - Extended options.
     * @param {Array[]} args - Additional arguments.
     * @returns {Array<Collapse>} Array of Collapses.
     */
    function Plugin(option, args) {
        return this.each(function() {
            var $this   = $(this);
            var data    = $this.data('bs.collapse');
            var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option);

            if (!data && options.toggle && (/show|hide/).test(option)) options.toggle = false;
            if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)));
            if (typeof option == 'string') data[option](args);
        });
    }

    var old = $.fn.collapse;

    $.fn.collapse             = Plugin;
    $.fn.collapse.Constructor = Collapse;

    // COLLAPSE NO CONFLICT
    // ====================

    $.fn.collapse.noConflict = function() {
        $.fn.collapse = old;

        return this;
    };

    // COLLAPSE DATA-API
    // =================

    /**
     * @param {Event} e
     * @event click.bs.collapseLayer.data-api
     */
    $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function(e) {
        var $this   = $(this);

        if (!$this.attr('data-target')) e.preventDefault();

        var $target = getTargetFromTrigger($this);
        var data    = $target.data('bs.collapse');
        var option  = data ? 'toggle' : $this.data();
        Plugin.call($target, option);
    });

    /**
     * @param {Event} e
     * @event click.bs.collapseLayer.data-api
     */
    $(document).on('click.bs.collapse.data-api', '[data-show="collapse"]', function(e) {
        var $this   = $(this);

        if (!$this.attr('data-target')) e.preventDefault();

        var $target = getTargetFromTrigger($this);
        var data    = $target.data('bs.collapse');
        var option  = data ? 'show' : $this.data();
        Plugin.call($target, option);
    });

    /**
     * @param {Event} e
     * @event click.bs.collapseLayer.data-api
     */
    $(document).on('click.bs.collapse.data-api', '[data-hide="collapse"]', function(e) {
        var $this   = $(this);

        if (!$this.attr('data-target')) e.preventDefault();

        var $target = getTargetFromTrigger($this);
        var data    = $target.data('bs.collapse');
        var option  = data ? 'hide' : $this.data();

        Plugin.call($target, option);
    });

    /**
     * @param {Event} e
     * @event click.bs.collapseLayer.data-api
     */
    $(document).on('click.bs.collapse.data-api', '[data-toggle="collapseGroup"]', function(e) {
    // $(document).on('click.bs.collapse.data-api', '[data-toggle]', function(e) {
        var $this   = $(this);
        var action = "toggle";
        var visible = 0;

        if (!$this.attr('data-target')) e.preventDefault();

        var $target = getTargetFromTrigger($this);

        for(var i = 0; i < $target.length; i++){
            var $el = $($target[i]);
            if( $el.hasClass('is-visible')){
                visible ++;
            }
        }

        if (visible < $target.length ){
            action = "show";
            // $this.addClass("is-active")
        } else {
            action = "hide";
            // $this.removeClass("is-active")
        }

        var data    = $target.data('bs.collapse');
        var option  = data ? action : $this.data();
        Plugin.call($target, option);
    });
}(jQuery);
